import { IResponse } from "models";

export enum ActionType {
  GET_CONSENT_STATEMENT = "action/GET_CONSENT_STATEMENT",
  GET_CONSENT_STATEMENT_SUCCESS = "action/GET_CONSENT_STATEMENT_SUCCESS",
  GET_CONSENT_STATEMENT_ERROR = "action/GET_CONSENT_STATEMENT_ERROR",
  GET_CONSENT_STATEMENT_RESET = "action/GET_CONSENT_STATEMENT_RESET",
}

export interface Action<T> {
  type: ActionType;
  payload: T;
}

export interface IConsentStatementResponse extends IResponse {
  result: {
    term_content: string;
  };
}
